export function error(...params) {
  console.error(...params);
  Rollbar.error(...params);
}
